import React from "react";
import { Paper, Space, Tabs, Text } from "@mantine/core";
import { PageLayout } from "../../../components/layout";
import { IconCreditCard, IconReceipt } from "@tabler/icons";
import { useNavigate, useParams } from "react-router";
import { AccountSupplierList } from "../account-supplier/list";
import { AccountBuyerList } from "../account-buyer/list";
import { useSelector } from "react-redux";
import { IAuth } from "../../../interfaces/IAuth";

export function AccountTabs() {
  const params = useParams();
  const navigate = useNavigate();
  const [tabKey, setTabKey] = React.useState<string | null>(params.type || "SUPPLIER");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  const titles = (val: string) => {
    switch (val) {
      case "SUPPLIER": {
        return "Олгосон зээлийн данс";
      }

      case "BUYER": {
        return "Олгосон зээлийн данс";
      }
    }
  };

  const onChange = (value: string) => {
    navigate(`/cf/account/${value}`);
    setTabKey(value);
  };

  const breadcrumbs = useBreadcrumb(titles(tabKey as string));

  return (
    <PageLayout
      title={tabKey === "SUPPLIER" ? "Нийлүүлэгчийн зээлийн дансны жагсаалт" : "Худалдан авагчийн зээлийн дансны жагсаалт"}
      subTitle={tabKey === "SUPPLIER" ? "Санхүүжилт олгосон зээлийн дансны мэдээлэл" : "Санхүүжилт олгосон зээлийн дансны мэдээлэл"}
      breadcrumb={breadcrumbs}
      extra={[]}>
      <Paper radius="sm" p="md" withBorder>
        <Tabs value={tabKey} onTabChange={(e) => onChange(e as string)}>
          <Tabs.List>
            {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_ACCOUNT_SUPPLIER") && (
              <Tabs.Tab value="SUPPLIER" icon={<IconCreditCard color={tabKey === "SUPPLIER" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Нийлүүлэгчид
                </Text>
              </Tabs.Tab>
            )}
            {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_ACCOUNT_BUYER") && (
              <Tabs.Tab value="BUYER" icon={<IconReceipt color={tabKey === "BUYER" ? "#3e166e" : "#44566C"} />}>
                <Text size="sm" weight={500} c="#44566C">
                  Худалдан авагчид
                </Text>
              </Tabs.Tab>
            )}
          </Tabs.List>
          <Space h={10} />
          {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_ACCOUNT_SUPPLIER") && (
            <Tabs.Panel value="SUPPLIER">{<AccountSupplierList />}</Tabs.Panel>
          )}
          {(user?.permissions || []).filter((c) => c.module === "LBF" && c.code === "LBF_ACCOUNT_BUYER") && (
            <Tabs.Panel value="BUYER">{<AccountBuyerList />}</Tabs.Panel>
          )}
        </Tabs>
      </Paper>
    </PageLayout>
  );
}

const useBreadcrumb = (type: any) => [
  {
    to: "/",
    label: "Үндсэн",
  },
  { label: "Зээл суурьтай санхүүжилт" },
  {
    label: type,
  },
];
